import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { EntranceDateSubForm, Schema as EntranceDateSchema } from '../subforms/EntranceDate';
import { SalaryRequestSubForm, Schema as SalaryRequestSchema } from '../subforms/SalaryRequest';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const HuettenesAlbertusStandardSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(NameAndContactSchema(settings))
        .concat(EntranceDateSchema)
        .concat(SalaryRequestSchema)
        .concat(OtherInformationSchema(settings))
        .concat(DocumentsSchema(settings))
);

export const HuettenesAlbertusStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={SalutationSubForm} colors={colors} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />
            <Field component={SalaryRequestSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}